/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const HandPlatter = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 3V2" }],
    ["path", { d: "M5 10a7.1 7.1 0 0 1 14 0" }],
    ["path", { d: "M4 10h16" }],
    ["path", { d: "M2 14h12a2 2 0 1 1 0 4h-2" }],
    [
      "path",
      {
        d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18"
      }
    ],
    ["path", { d: "M5 14v7H2" }]
  ]
];

export { HandPlatter as default };
//# sourceMappingURL=hand-platter.js.map
